export default {
  order: {
    title: "Order",
    pickupDate: "Pick Up Date",
    pickup: "Pick Up",
    dropoff: "Drop Off",
    passenger: "Passenger",
    comment: "Comment",
    vehicle: "Vehicle",
    chauffeur: "Chauffeur",
    passengersCount: "Passengers",
    childSeats: "Child seats",
    flightNumber: "Flight number",
    nameSign: "Name Sign",
    speaks: "Speaks",
    call: "Call",
    licensePlate: "License plate number",
    category: "Category",
    status: {
      new: "Pending Confirmation",
      confirmed: "Order Confirmed",
      on_my_way: "En Route",
      at_the_location: "Arrived Location",
      pob: "Passenger Onboard",
      clear: "Order Completed",
      no_show: "Passenger No-Show",
      canceled: "Order Canceled"
    },
    statusDescriptions: {
      new: "Order pending supplier confirmation",
      confirmed: "Supplier confirmed order, awaiting start",
      on_my_way: "Driver en route to pick-up location",
      at_the_location: "Driver arrived and waiting for passenger",
      pob: "Passenger boarded, en route to destination",
      clear: "Order completed successfully",
      no_show: "Passenger did not appear at the pick-up location",
      canceled: "Order canceled"
    },
    messages: {
      noChauffeurAssigned: "Your chauffeur has not been assigned yet",
      detailsWillAppear: "Details will appear here once assigned",
      unknown: "Unknown",
      started: "Started",
      awaitingAssignment: "Awaiting assignment"
    },
    childSeatsTypes: {
      child_01: "Infant carrier (6 month)",
      child_02: "Convertible seat (0-7 years)",
      child_03: "Booster seat (6-12 years)"
    },
    distance: "{distance} km",
    review: "Rate your trip",
    review_status: {
      perfect: 'Perfect',
      good: 'Good',
      average: 'Average',
      bad: 'Bad',
      terrible: 'Terrible'
    },
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    loading: "Loading...",
    error: "Error"
  }
}